import React, { createContext } from "react";
export const HeaderMobileMenuIsOpen = createContext({
  headerMobileMenuIsOpen: false,
  setHeaderMobileMenuIsOpen: () => {},
});
